var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 0H12.0859L13.7574 20H15.3002L13.5002 0Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14284 0H6.55713L4.8857 20H3.34284L5.14284 0Z",
    fill: "#2EC5CE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 14.7505,
    width: 16.5,
    height: 1.5,
    fill: "#75E3EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2.30811,
    width: 18,
    height: 10.5128,
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0583 8.17045C11.504 8.85696 10.6659 9.39048 10.2998 10.1999C10.1364 10.5606 10.7364 10.8261 10.9989 10.855C11.54 10.9152 12.0205 10.7448 12.5012 10.5545C12.5454 10.7465 12.6911 10.9174 13.0145 11.0702C13.7259 11.4069 14.5295 11.131 15.2131 10.8468C15.5929 10.689 14.7545 10.0216 14.3822 10.1764C14.173 10.2633 13.9592 10.3276 13.7415 10.3895C13.3112 10.5114 13.5621 10.4418 13.698 10.097C13.8473 9.71957 13.2013 9.38438 12.8937 9.45172C12.5634 9.52408 12.2457 9.66378 11.9274 9.79585C12.559 9.12634 13.3299 8.55991 13.5393 7.62036C13.617 7.27144 12.9706 7.00359 12.7109 7.05437C11.0983 7.3693 9.6601 8.30688 8.08751 8.72772C8.79017 7.85727 9.70663 7.16312 10.3689 6.24668C10.6128 5.90931 9.8098 5.54273 9.56461 5.60136C7.86537 6.00847 6.14702 6.7255 4.38544 6.76974C5.36402 5.94374 6.635 5.51331 7.71368 4.81721C8.09278 4.57224 7.21978 3.9291 6.88239 4.14682C5.52076 5.02621 3.93061 5.49914 2.87322 6.78543C2.65919 7.04565 3.27537 7.39654 3.45251 7.42574C5.17502 7.70819 6.79459 7.2867 8.42029 6.8288C7.73739 7.51183 7.02222 8.16217 6.56849 9.03763C6.39793 9.36673 7.00927 9.70366 7.26741 9.69277C8.99651 9.62019 10.4745 8.74298 12.0583 8.17045Z",
    fill: "#8C30F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictionary);
export default __webpack_public_path__ + "static/media/Pictionary.b834efada5fee1de40df05f6089071ab.svg";
export { ForwardRef as ReactComponent };